/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const ACTIVE_SERVER_ID: number = 201;
export const STATIC_DOMAINS = {"s3": ["mkskimgmodrykonik.vshcdn.net"], "files": ["filesmodrykonik.vshcdn.net"], "asset": ["mkskasmodrykonik.vshcdn.net"]};
export const IS_PROD = true;
export const JAM_ENDPOINT = "wss://sjam.modrykonik.com";
export const API_ENDPOINT = "https://www.modrykonik.sk";
export const BASE_URL = "https://www.modrykonik.sk";
export const API_VERSION_STRING = "v1-2019-03-27T09:13:10";
export const FACEBOOK_APP_ID = "156236697748777";
export const GCSE_CX = "009353289491508936351:nepirbl3uii";
